/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpOrganization } from '../models/GcpOrganization';

export class ActivateGcpFolderResponse {
  'gcpFolder': GcpOrganization;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "gcpFolder",
      "baseName": "gcpFolder",
      "type": "GcpOrganization",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ActivateGcpFolderResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

